import { render, staticRenderFns } from "./escalaAnualLicencaPremioRh.vue?vue&type=template&id=349e15a9&"
import script from "./escalaAnualLicencaPremioRh.vue?vue&type=script&lang=js&"
export * from "./escalaAnualLicencaPremioRh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports